import {Injectable, Inject} from 'ng-metadata/core';

interface HtmlBody {
    createTextRange?(): Range;
}

@Injectable()
export class SelectTextUtil{
    
    //selects (highlights) text under element with id elementId  
    selectText(elementId) {
        let doc = document;
        let text = doc.getElementById(elementId);
        let body: HtmlBody = doc.body;
        if (body.createTextRange) { // ms
            let range = body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else if (window.getSelection) {
            let selection = window.getSelection();
            let range = doc.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/selectTextUtil.ts